import React from 'react';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const fleetInsightPlugin = createPlugin({
  id: 'fleet-insight',
  routes: {
    root: rootRouteRef,
  },
});

export const FleetInsightPage = fleetInsightPlugin.provide(
  createRoutableExtension({
    name: 'FleetInsightPage',
    component: () =>
      import('./components/FleetInsightPage').then(m => {
        const Component = m.FleetInsightPage;
        return (props: any) => {
          return React.createElement(Component, props);
        };
      }),
    mountPoint: rootRouteRef,
  }),
);
